// export const BACKEND_SERVER_URL = "https://mern-blog-backend-bomv.onrender.com";
// export const BACKEND_SERVER_URL = "https://mern-blogg-backend.onrender.com";
// export const BACKEND_SERVER_URL = "http://localhost:4000";
export const BACKEND_SERVER_URL = "https://mern-blogg-backend.onrender.com";

